import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { SampleRecapButton } from 'features/meeting_intelligence';
import { NotetakerButton } from './notetaker_button';
const styledButtonContainerIsPhoneCss = "sslvaxy";
const styledButtonContainerCss = "sfakk1u";
const StyledButtonContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(styledButtonContainerCss, {
    [styledButtonContainerIsPhoneCss]: isPhone
  }, props.className)} />;
});
export const ButtonContainer = ({
  contentKey,
  text
}) => <StyledButtonContainer>
    <NotetakerButton contentKey={contentKey} text={text} />
    <SampleRecapButton />
  </StyledButtonContainer>;

require("./button_container.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./button_container.js");